import { ScaleLoader } from 'react-spinners'

export default function PreLoader() {
  return (
    <div className='w-screen h-screen flex justify-center items-center bg-gray-400'>
    <ScaleLoader color='#1B44FE' height='50px' width='5px' />
    </div>
  )
}